import { render, staticRenderFns } from "./collector.vue?vue&type=template&id=4c0af5c6"
import script from "./collector.vue?vue&type=script&lang=js"
export * from "./collector.vue?vue&type=script&lang=js"
import style0 from "./collector.vue?vue&type=style&index=0&id=4c0af5c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports